module.exports = __webpack_public_path__ + "static/media/brand.a1b1784f.png";